import React from 'react';
import { FaBatteryThreeQuarters, FaClock, FaThermometerHalf, FaTint, FaWind, FaCompass } from 'react-icons/fa';

const SensorPopup = ({ sensor }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const renderSensorDetails = () => {
    switch (sensor.type) {
      case 'moisture':
        return (
          <>
            <div className="sensor-value">
              <FaTint style={{ color: 'var(--accent-blue)' }} />
              <span>{sensor.value}{sensor.unit}</span>
            </div>
            {sensor.alert && (
              <div className="sensor-alert">
                <span style={{ color: 'var(--accent-red)' }}>{sensor.alertMessage}</span>
              </div>
            )}
          </>
        );
      case 'temperature':
        return (
          <div className="sensor-value">
            <FaThermometerHalf style={{ color: 'var(--accent-red)' }} />
            <span>{sensor.value}{sensor.unit}</span>
          </div>
        );
      case 'weather':
        return (
          <>
            <div className="sensor-value">
              <FaThermometerHalf style={{ color: 'var(--accent-red)' }} />
              <span>{sensor.temperature}°C</span>
            </div>
            <div className="sensor-value">
              <FaTint style={{ color: 'var(--accent-blue)' }} />
              <span>{sensor.humidity}%</span>
            </div>
            <div className="sensor-value">
              <FaWind style={{ color: 'var(--text-secondary)' }} />
              <span>{sensor.windSpeed} km/h</span>
            </div>
            <div className="sensor-value">
              <FaCompass style={{ color: 'var(--text-secondary)' }} />
              <span>{sensor.windDirection}</span>
            </div>
          </>
        );
      case 'irrigation':
        return (
          <div className="sensor-value">
            <FaTint style={{ color: 'var(--accent-blue)' }} />
            <span>{sensor.flowRate} {sensor.unit}</span>
            <div className="sensor-status">
              Status: <span style={{ color: sensor.status === 'active' ? 'var(--accent-green)' : 'var(--text-secondary)' }}>
                {sensor.status}
              </span>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="sensor-popup">
      <h3>{sensor.name}</h3>
      {renderSensorDetails()}
      <div className="sensor-meta">
        <div className="sensor-battery">
          <FaBatteryThreeQuarters style={{ color: sensor.battery > 20 ? 'var(--accent-green)' : 'var(--accent-red)' }} />
          <span>{sensor.battery}%</span>
        </div>
        <div className="sensor-time">
          <FaClock style={{ color: 'var(--text-secondary)' }} />
          <span>{formatDate(sensor.lastUpdated)}</span>
        </div>
      </div>
    </div>
  );
};

export default SensorPopup; 